export const HIGHCHARTS_DATE_TIME_LABEL_FORMATS = {
  millisecond: '%I:%M:%S.%L %P',
  second: '%I:%M:%S %P',
  minute: '%I:%M %P',
  hour: '%I:%M %P',
  day: '%b %e',
  week: '%b %e',
  month: "%b '%y",
  year: '%Y',
};

export const abbrNumber = (number, digits = 2) => {
  if (number === 0) {
    return '0';
  }
  if (!number) {
    return number;
  }
  const units = [
    { value: 1e33, symbol: 'D' },
    { value: 1e15, symbol: 'Q' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' },
    { value: 1, symbol: '' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const absNumber = Math.abs(number);
  const selected = units.filter((unit) => {
    if (absNumber >= unit.value) {
      return unit;
    }
    return undefined;
  })[0];
  return `${number < 0 ? '-' : ''}${(absNumber / selected.value)
    .toFixed(digits)
    .replace(rx, '$1')}${selected.symbol}`;
};
